"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerFormats = exports.INPUT_REGEX = exports.DELIMITER_REGEX = exports.DELIMITERS = void 0;
// See https://en.wikipedia.org/wiki/Date_format_by_country
const datePickerFormats = [
// ISO 8601 variants
"yy-mm-dd", "yy/mm/dd",
// Common writing formats across many nations/locales.
"yyyy/dd/mm", "yyyy-dd-mm", "mm/dd/yyyy", "mm-dd-yyyy", "mm/dd/yy",
// most common US.
"dd/mm/yyyy", "dd-mm-yyyy", "dd.mm.yyyy",
// Finnish (Finland)
"dd/mm/yy", "dd.mm.yy", "dd.mm.yy.",
// Serbia/Montenegro/Czechia variant.

// Hungarian variants
"yyyy.mm.dd.", "yyyy.mm.dd",
// Many Eastern European countries: Bosnia and Herzegovina, Czechia, Croatia, etc.
"dd. mm. yyyy",
// en-ZA English South Africa
"yyyy/mm/dd",
// Chinese - Hong Kong
"yy年mm月dd日",
// Latvia
"yy.dd.mm",
// Korean (North and South).
"yy. mm. dd",
// Spanish - PR, Nicaragua, El Salvador, Honduras.
"mm-dd-yy",
// Dutch - Netherlands, Portuguese, some Spanish locales.
"dd-mm-yy"];
exports.datePickerFormats = datePickerFormats;
const DELIMITERS = datePickerFormats.join("").split("").sort().filter((item, pos, arr) => arr[pos + 1] !== arr[pos] && !"mdy".includes(arr[pos])).join("");
exports.DELIMITERS = DELIMITERS;
const DELIMITER_REGEX = new RegExp("[" + DELIMITERS + "]");

// Storing the regex for checking typed characters. This regex
// is all possible delimiter and input characters.
exports.DELIMITER_REGEX = DELIMITER_REGEX;
const INPUT_REGEX = new RegExp("[^0-9" + DELIMITERS + "]");

/**
 * The allowed set of date string formats e.g. "mm/dd/yyyy".
 */

/**
 * These are just the props the Date pickers need from the Flyout.
 */
exports.INPUT_REGEX = INPUT_REGEX;
//# sourceMappingURL=types.js.map